import client from 'data/client';
import { OrdersData } from 'data/types/orders';
import { normalizeOrder } from 'model/orders';
import { CDError } from 'utils/error';

const getOrders = async () => {
  try {
    const response = await client.get<OrdersData>(`/orders/active_orders`);

    return response.data.map(normalizeOrder);
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.response.data.message);
  }
};

export default getOrders;
